import { render, staticRenderFns } from "./TablePageLayout.vue?vue&type=template&id=5894dddd&"
import script from "./TablePageLayout.vue?vue&type=script&lang=js&"
export * from "./TablePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./TablePageLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports